import { lazy } from 'react';
import Loadable from 'components/Loadable';
import StaticEmployeeMaster from 'static-solutions/24155/identity-solution/employee-master/index';
import StaticCOEEmployeeMaster from 'static-solutions/24155/identity-solution/employee-master/COE-Employee';
import StaticDetailsEmployeeMaster from 'static-solutions/24155/identity-solution/employee-master/Details-Employee';
import StaticProcessRoleEdit from 'static-solutions/24155/identity-solution/processrole-master/Edit';
import StaticProcessRoleMaster from 'static-solutions/24155/identity-solution/processrole-master/index';
import StaticProcessRoleCreate from 'static-solutions/24155/identity-solution/processrole-master/Create';
import StaticProcessRoleDetails from 'static-solutions/24155/identity-solution/processrole-master/Details';
import StaticCommittee from 'static-solutions/24155/identity-solution/committee/index';
import StaticCOECommittee from 'static-solutions/24155/identity-solution/committee/COECommittee';
import StaticCommitteeEdit from 'static-solutions/24155/identity-solution/committee/Edit';
import StaticDetailsCommittee from 'static-solutions/24155/identity-solution/committee/DetailsCommittee';
import StaticLeave from 'static-solutions/24155/policy-solution/leave-combined/Create';
import StaticAnnualLeaveCreate from 'static-solutions/24155/policy-solution/leave/Create';
import StaticLeaveUpdate from 'static-solutions/24155/policy-solution/leave-combined/Update';
import StaticLeaveDetails from 'static-solutions/24155/policy-solution/leave-combined/Details';
import StaticControlQuestionnaire from 'static-solutions/24155/identity-solution/control-questionnaire/Create';
import StaticAssignControlQuestionnaire from 'static-solutions/24155/identity-solution/assign-control-questionnaire/Create';
import AssignControlSelfAssurance from 'static-solutions/24155/policy-solution/assign-control-for-self-assurance/Create';
import StaticLeaseRecordSimulator from 'static-solutions/24155/identity-solution/lease-simulator/CreateNew';
import StaticLeaseRecordManagement from 'static-solutions/24155/identity-solution/lease-record-management/Create';
import StaticLeaseRecordManagementEdit from 'static-solutions/24155/identity-solution/lease-record-management/Edit';
import StaticLeaseRecordManagementV2 from 'static-solutions/24155/identity-solution/lease-record-management-v2/Create';
import StaticLeaseRecordManagementEditV2 from 'static-solutions/24155/identity-solution/lease-record-management-v2/Edit';
import StaticDecommissionAssetV6 from 'static-solutions/24155/identity-solution/decommission-asset/Create';
import StaticDecommissionAssetEditV6 from 'static-solutions/24155/identity-solution/decommission-asset/Edit';
import StaticDecommissionAssetReviseV6 from 'static-solutions/24155/identity-solution/decommission-asset/Revise';
import StaticLeaseRecordManagementV6 from 'static-solutions/24155/identity-solution/lease-record-management-v6/Create';
import StaticLeaseRecordManagementEditV6 from 'static-solutions/24155/identity-solution/lease-record-management-v6/Edit';
import StaticLeaseRecordManagementDecommissionAssetV6 from 'static-solutions/24155/identity-solution/decommission-asset/index';
import StaticLeaseRecordManagementDataTableV6 from 'static-solutions/24155/identity-solution/lease-record-management-v6/index';
import CombinedLeaveListPage from 'static-solutions/24155/policy-solution/leave-combined/index.jsx';
import StaticLeaseRecordManagementV7 from 'static-solutions/24155/identity-solution/lease-record-management-v7/Create';
import StaticLeaseRecordManagementEditV7 from 'static-solutions/24155/identity-solution/lease-record-management-v7/Edit';
import AssignControlSelfAssuranceV2 from 'static-solutions/24155/policy-solution/assign-control-for-self-assurance-v2/CreateV2';
import StaticControlTesting from 'static-solutions/24155/identity-solution/control-testing/Create';
import StaticFloatCreationCreate from 'static-solutions/25118/identity-solution/float-creation/Create';

// Attendance Solution Static
import StaticAttendanceShiftCreate from 'static-solutions/24155/policy-solution/shift/Create';
import AttendanceManagement from 'static-solutions/24155/console-solution/attendance-management/index';
import StaticControl from 'static-solutions/24155/console-solution/control/index';
import BudgetaryControl from 'static-solutions/24155/console-solution/budgetary-control/index';
import ControlSelfAssurance from 'static-solutions/24155/console-solution/control-self-assurance/index';
import ControlSelfAssuranceV2 from 'static-solutions/24155/console-solution/compliance-tracker/index';
import LeaseRecordManagementV9Edit from 'static-solutions/24155/identity-solution/lease-v9-new-version/lease-record-management-v9-new-version/edit/LeaseRecordManagementV9Edit';
import LeaseRecordManagementV9Modify from 'static-solutions/24155/identity-solution/lease-v9-new-version/lease-record-management-v9-new-version/modify/LeaseRecordManagementV9Modify';
import LeaseRecordManagementV9Details from 'static-solutions/24155/identity-solution/lease-v9-new-version/lease-record-management-v9-new-version/details/LeaseRecordManagementV9Details';
import LeaseTrailModeV9NewCreate from 'static-solutions/24155/identity-solution/lease-v9-new-version/lease-trail-mode-v9-new/create/LeaseV9NewTrailModeCreate';
import LeaseV9NewTrailModeView from '../static-solutions/24155/identity-solution/lease-v9-new-version/lease-trail-mode-v9-new/view/LeaseV9NewTrailModeView';
import LeaseV9NewTrailModeModify from '../static-solutions/24155/identity-solution/lease-v9-new-version/lease-trail-mode-v9-new/modify/LeaseV9NewTrailModeModify';
import KpiComparativeConsole from 'static-solutions/24155/console-solution/kpi-comparative-console/index';

const LeaseSchedule = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule/index')));
const LeaveManagement = Loadable(lazy(() => import('static-solutions/24155/console-solution/leave-management/index')));
const LeadCreationList = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-creation/LeadCreationList')));
const LeadCreationCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-creation/LeadCreationCreatePage')));
const LeadCreationEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-creation/LeadCreationEditPage')));
const LeadCreationViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-creation/LeadCreationViewPage')));
const RawSourcingRequestCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/raw-sourcing-request/RawSourcingRequestCreatePage'))
);
const RawSourcingRequestEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/raw-sourcing-request/RawSourcingRequestEditPage'))
);
const RawSourcingRequestViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/raw-sourcing-request/RawSourcingRequestViewPage'))
);
const RfqStrategyPlanningEntryCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/rfq-strategy-planning-entry/RfqStrategyPlanningEntryCreatePage'))
);
const RfqStrategyPlanningEntryEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/rfq-strategy-planning-entry/RfqStrategyPlanningEntryEditPage'))
);
const RfqStrategyPlanningEntryViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/rfq-strategy-planning-entry/RfqStrategyPlanningEntryViewPage'))
);
const ProcurementProgressionProfileCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/procurement-progression-profile/ProcurementProgressionProfileCreatePage'))
);
const ProcurementProgressionProfileEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/procurement-progression-profile/ProcurementProgressionProfileEditPage'))
);
const ProcurementProgressionProfileViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/procurement-progression-profile/ProcurementProgressionProfileViewPage'))
);
const LeadStageSlaProfilesCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lead-stage-sla-profiles/LeadStageSlaProfilesCreatePage'))
);
const LeadStageSlaProfilesEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lead-stage-sla-profiles/LeadStageSlaProfilesEditPage'))
);
const LeadStageSlaProfilesViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lead-stage-sla-profiles/LeadStageSlaProfilesViewPage'))
);
const PreLitigationLifecycleEffortProfileCreatePage = Loadable(
	lazy(
		() => import('static-solutions/24155/identity-solution/pre-litigation-lifecycle-effort-profile/PreLitigationLifecycleEffortProfileCreatePage')
	)
);
const PreLitigationLifecycleEffortProfileEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/pre-litigation-lifecycle-effort-profile/PreLitigationLifecycleEffortProfileEditPage'))
);
const PreLitigationLifecycleEffortProfileViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/pre-litigation-lifecycle-effort-profile/PreLitigationLifecycleEffortProfileViewPage'))
);
const RecruitmentLifecycleEffortProfileCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/recruitment-lifecycle-effort-profile/RecruitmentLifecycleEffortProfileCreatePage'))
);
const RecruitmentLifecycleEffortProfileEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/recruitment-lifecycle-effort-profile/RecruitmentLifecycleEffortProfileEditPage'))
);
const RecruitmentLifecycleEffortProfileViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/recruitment-lifecycle-effort-profile/RecruitmentLifecycleEffortProfileViewPage'))
);
const LitigationLifecycleEffortProfileCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/litigation-lifecycle-effort-profile/LitigationLifecycleEffortProfileCreatePage'))
);
const LitigationLifecycleEffortProfileEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/litigation-lifecycle-effort-profile/LitigationLifecycleEffortProfileEditPage'))
);
const LitigationLifecycleEffortProfileViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/litigation-lifecycle-effort-profile/LitigationLifecycleEffortProfileViewPage'))
);
const SourcingRequestPoolParallelCreatePage = Loadable(
	lazy(
		() =>
			import('static-solutions/24155/identity-solution/sourcing-request-pool-with-parallel-requirements/SourcingRequestPoolParallelCreatePage')
	)
);
const SourcingRequestPoolParallelList = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/sourcing-request-pool-with-parallel-requirements/SourcingRequestPoolParallelList'))
);
const SourcingRequestPoolParallelEditPage = Loadable(
	lazy(
		() => import('static-solutions/24155/identity-solution/sourcing-request-pool-with-parallel-requirements/SourcingRequestPoolParallelEditPage')
	)
);
const SourcingRequestPoolParallelDetailsPage = Loadable(
	lazy(
		() =>
			import('static-solutions/24155/identity-solution/sourcing-request-pool-with-parallel-requirements/SourcingRequestPoolParallelDetailsPage')
	)
);
const AttendanceSummary = Loadable(lazy(() => import('static-solutions/24155/console-solution/my-attendance/index')));
const StaticLeaseAgreement = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-agreement/Create')));
const StaticLeaseAgreementDetails = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-agreement/Details')));
const StaticLeaseAgreementEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-agreement/Edit')));
const LandRecordList = Loadable(lazy(() => import('static-solutions/24155/identity-solution/land-record/LandRecordList')));
const LandRecordCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/land-record/LandRecordCreatePage')));
const LandRecordEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/land-record/LandRecordEditPage')));
const LandRecordViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/land-record/LandRecordViewPage')));
const LandDocumentManagementCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-document-management/LandDocumentManagementCreatePage'))
);
const LandDocumentManagementEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-document-management/LandDocumentManagementEditPage'))
);
const LandDocumentManagementViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-document-management/LandDocumentManagementViewPage'))
);
const StaticTaskAttachment = Loadable(lazy(() => import('static-solutions/24155/identity-solution/task-attachment/Create')));
const StaticTaskAttachmentEditAndDetails = Loadable(lazy(() => import('static-solutions/24155/identity-solution/task-attachment/Edit')));
const StaticOcrAiSolution = Loadable(lazy(() => import('static-solutions/24155/identity-solution/ocr-ai-solution/Create')));
const StaticElectricityBillUpload = Loadable(lazy(() => import('static-solutions/24155/identity-solution/electricity-bill-upload/Create')));
const ConvertPreLitigationToLitigationCaseList = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/convert-pre-litigation-to-litigation-case/ConvertPreLitigationToLitigationCaseList'))
);
const ConvertPreLitigationToLitigationCaseCreatePage = Loadable(
	lazy(
		() =>
			import('static-solutions/24155/identity-solution/convert-pre-litigation-to-litigation-case/ConvertPreLitigationToLitigationCaseCreatePage')
	)
);
const ConvertPreLitigationToLitigationCaseEditPage = Loadable(
	lazy(
		() =>
			import('static-solutions/24155/identity-solution/convert-pre-litigation-to-litigation-case/ConvertPreLitigationToLitigationCaseEditPage')
	)
);
const ConvertPreLitigationToLitigationCaseViewPage = Loadable(
	lazy(
		() =>
			import('static-solutions/24155/identity-solution/convert-pre-litigation-to-litigation-case/ConvertPreLitigationToLitigationCaseViewPage')
	)
);
const PreLitigationMatterRegistrationList = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/pre-litigation-matter-registration/PreLitigationMatterRegistrationList'))
);
const PreLitigationMatterRegistrationCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/pre-litigation-matter-registration/PreLitigationMatterRegistrationCreatePage'))
);
const PreLitigationMatterRegistrationEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/pre-litigation-matter-registration/PreLitigationMatterRegistrationEditPage'))
);
const PreLitigationMatterRegistrationViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/pre-litigation-matter-registration/PreLitigationMatterRegistrationViewPage'))
);
const LawFirmRecordEntryList = Loadable(lazy(() => import('static-solutions/24155/identity-solution/law-firm-record-entry/LawFirmRecordEntryList')));
const LawFirmRecordEntryCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/law-firm-record-entry/LawFirmRecordEntryCreatePage'))
);
const LawFirmRecordEntryEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/law-firm-record-entry/LawFirmRecordEntryEditPage'))
);
const LawFirmRecordEntryViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/law-firm-record-entry/LawFirmRecordEntryViewPage'))
);
const LandRecurringActionManagementList = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-recurring-action-management/LandRecurringActionManagementList'))
);
const LandRecurringActionManagementCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-recurring-action-management/LandRecurringActionManagementCreatePage'))
);
const LandRecurringActionManagementEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-recurring-action-management/LandRecurringActionManagementEditPage'))
);
const LandRecurringActionManagementViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-recurring-action-management/LandRecurringActionManagementViewPage'))
);
const LawerRecordEntryList = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lawer-record-entry/LawerRecordEntryList')));
const LawerRecordEntryCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lawer-record-entry/LawerRecordEntryCreatePage'))
);
const LawerRecordEntryEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lawer-record-entry/LawerRecordEntryEditPage')));
const LawerRecordEntryViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lawer-record-entry/LawerRecordEntryViewPage')));
const VendorRegistrationRequestCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/vendor-registration-request/VendorRegistrationRequestCreatePage'))
);
const VendorRegistrationRequestList = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/vendor-registration-request/VendorRegistrationRequestList'))
);
const VendorRegistrationRequestEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/vendor-registration-request/VendorRegistrationRequestEditPage'))
);
const VendorRegistrationRequestViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/vendor-registration-request/VendorRegistrationRequestViewPage'))
);
const VendorRegistrationMultiFormCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/vendor-registration-multi-form/VendorRegistrationMultiFormCreatePage'))
);
const VendorRegistrationMultiFormEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/vendor-registration-multi-form/VendorRegistrationMultiFormEditPage'))
);
const VendorRegistrationMultiFormViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/vendor-registration-multi-form/VendorRegistrationMultiFormViewPage'))
);
const BusinessCaseCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/business-case/BusinessCaseCreatePage')));
const BusinessCaseEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/business-case/BusinessCaseEditPage')));
const BusinessCaseList = Loadable(lazy(() => import('static-solutions/24155/identity-solution/business-case/BusinessCaseList')));
const BusinessCaseViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/business-case/BusinessCaseViewPage')));
const BankAccountMasterCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/bank-account-master/BankAccountMasterCreatePage'))
);
const BankAccountMasterEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/bank-account-master/BankAccountMasterEditPage'))
);
const BankAccountMasterList = Loadable(lazy(() => import('static-solutions/24155/identity-solution/bank-account-master/BankAccountMasterList')));
const BankAccountMasterViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/bank-account-master/BankAccountMasterViewPage'))
);
const IntercompanyFundRequestCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/intercompany-fund-request/IntercompanyFundRequestCreatePage'))
);
const IntercompanyFundRequestEditPage = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/intercompany-fund-request/IntercompanyFundRequestEditPage'))
);
const IntercompanyFundRequestList = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/intercompany-fund-request/IntercompanyFundRequestList'))
);
const IntercompanyFundRequestViewPage = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/intercompany-fund-request/IntercompanyFundRequestViewPage'))
);
const DonorAllocationChildCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/donor-allocation-child/DonorAllocationChildCreatePage'))
);
const DonorAllocationChildEditPage = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/donor-allocation-child/DonorAllocationChildEditPage'))
);
const DonorAllocationChildList = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/donor-allocation-child/DonorAllocationChildList'))
);
const DonorAllocationChildViewPage = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/donor-allocation-child/DonorAllocationChildViewPage'))
);
const DisbursementCaseApprovalList = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/disbursement-case-approval/DisbursementCaseApprovalList'))
);
const DisbursementCaseApprovalViewPage = Loadable(
	lazy(() => import('static-solutions/24155/record-solution/disbursement-case-approval/DisbursementCaseApprovalViewPage'))
);
const PurchaseOrderCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/purcase-order/PurchaseOrderCreatePage')));
const PurchaseOrderEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/purcase-order/PurchaseOrderEditPage')));
const PurchaseOrderViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/purcase-order/PurchaseOrderViewPage')));
const InventoryTransactionCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/inventory-transaction/InventoryTransactionCreatePage'))
);
const InventoryTransactionEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/inventory-transaction/InventoryTransactionEditPage'))
);
const InventoryTransactionViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/inventory-transaction/InventoryTransactionViewPage'))
);
const DataPrivacyAssessmentCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/data-privacy-assessment/DataPrivacyAssessmentCreatePage'))
);
const DataPrivacyAssessmentEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/data-privacy-assessment/DataPrivacyAssessmentEditPage'))
);
const DataPrivacyAssessmentViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/data-privacy-assessment/DataPrivacyAssessmentViewPage'))
);
const HealthSafetyEnvironmentCheckCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/health-safety-environment-check/HealthSafetyEnvironmentCheckCreatePage'))
);
const HealthSafetyEnvironmentCheckEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/health-safety-environment-check/HealthSafetyEnvironmentCheckEditPage'))
);
const HealthSafetyEnvironmentCheckViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/health-safety-environment-check/HealthSafetyEnvironmentCheckViewPage'))
);
const InventoryTransferCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/inventory-transfer/InventoryTransferCreatePage'))
);
const InventoryTransferEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/inventory-transfer/InventoryTransferEditPage'))
);
const InventoryTransferViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/inventory-transfer/InventoryTransferViewPage'))
);
const ServiceReceiptCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/service-receipt/ServiceReceiptCreatePage')));
const ServiceReceiptEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/service-receipt/ServiceReceiptEditPage')));
const ServiceReceiptViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/service-receipt/ServiceReceiptViewPage')));
const GoodsReceiptCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/goods-receipt/GoodsReceiptCreatePage')));
const GoodsReceiptEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/goods-receipt/GoodsReceiptEditPage')));
const GoodsReceiptViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/goods-receipt/GoodsReceiptViewPage')));
const LegalExpenseProvisionCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/legal-expense-provision/LegalExpenseProvisionCreatePage'))
);
const LegalExpenseProvisionEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/legal-expense-provision/LegalExpenseProvisionEditPage'))
);
const LegalExpenseProvisionViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/legal-expense-provision/LegalExpenseProvisionViewPage'))
);
const PositionRequestCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/position-request/PositionRequestCreatePage')));
const PositionRequestEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/position-request/PositionRequestEditPage')));
const PositionRequestViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/position-request/PositionRequestViewPage')));
const HiringRequestCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/hiring-request/HiringRequestCreatePage')));
const HiringRequestEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/hiring-request/HiringRequestEditPage')));
const HiringRequestViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/hiring-request/HiringRequestViewPage')));
const IdentityLegalValidationViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/identity-legal-validation/IdentityLegalValidationViewPage'))
);
const IdentityLegalValidationEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/identity-legal-validation/IdentityLegalValidationEditPage'))
);
const AddressContactViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/address-contact/AddressContactViewPage')));
const AddressContactEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/address-contact/AddressContactEditPage')));
const BankPaymentInformationViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/bank-payment-information/BankPaymentInformationViewPage'))
);
const BankPaymentInformationEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/bank-payment-information/BankPaymentInformationEditPage'))
);
const CommercialProcurementSetupViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/commercial-procurement-setup/CommercialProcurementSetupViewPage'))
);
const CommercialProcurementSetupEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/commercial-procurement-setup/CommercialProcurementSetupEditPage'))
);
const ComplianceDeclarationRiskViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/compliance-declaration-risk/ComplianceDeclarationRiskViewPage'))
);
const ComplianceDeclarationRiskEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/compliance-declaration-risk/ComplianceDeclarationRiskEditPage'))
);
const BidSubmissionCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/bid-submission/BidSubmissionCreatePage')));
const BidSubmissionList = Loadable(lazy(() => import('static-solutions/24155/identity-solution/bid-submission/BidSubmissionList')));
const BidSubmissionEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/bid-submission/BidSubmissionEditPage')));
const BidSubmissionViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/bid-submission/BidSubmissionViewPage')));
const TechnicalEvaluationCriteriaConfigurationCreatePage = Loadable(
	lazy(
		() =>
			import('static-solutions/24155/identity-solution/technical-evaluation-criteria-configuration/TechnicalEvaluationCriteriaConfigurationCreatePage')
	)
);
const TechnicalEvaluationCriteriaConfigurationEditPage = Loadable(
	lazy(
		() =>
			import('static-solutions/24155/identity-solution/technical-evaluation-criteria-configuration/TechnicalEvaluationCriteriaConfigurationEditPage')
	)
);
const TechnicalEvaluationCriteriaConfigurationViewPage = Loadable(
	lazy(
		() =>
			import('static-solutions/24155/identity-solution/technical-evaluation-criteria-configuration/TechnicalEvaluationCriteriaConfigurationViewPage')
	)
);
const HearingScheduleCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/hearing-schedule/HearingScheduleCreatePage')));
const HearingScheduleEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/hearing-schedule/HearingScheduleEditPage')));
const HearingScheduleViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/hearing-schedule/HearingScheduleViewPage')));
const RfqPackageFinalizationCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/rfq-package-finalization/RfqPackageFinalizationCreatePage'))
);
const RfqPackageFinalizationEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/rfq-package-finalization/RfqPackageFinalizationEditPage'))
);
const RfqPackageFinalizationViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/rfq-package-finalization/RfqPackageFinalizationViewPage'))
);
const PaymentTermsMasterList = Loadable(lazy(() => import('static-solutions/24155/identity-solution/payment-terms-master/PaymentTermsMasterList')));
const PaymentTermsMasterCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/payment-terms-master/PaymentTermsMasterCreatePage'))
);
const PaymentTermsMasterEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/payment-terms-master/PaymentTermsMasterEditPage'))
);
const PaymentTermsMasterViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/payment-terms-master/PaymentTermsMasterViewPage'))
);
const PurchaseRequisitionCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/purchase-requisition/PurchaseRequisitionCreatePage'))
);
const PurchaseRequisitionEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/purchase-requisition/PurchaseRequisitionEditPage'))
);
const PurchaseRequisitionViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/purchase-requisition/PurchaseRequisitionViewPage'))
);
const SupplierDebitNoteCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/supplier-debit-note/SupplierDebitNoteCreatePage'))
);
const SupplierDebitNoteEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/supplier-debit-note/SupplierDebitNoteEditPage'))
);
const SupplierDebitNoteViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/supplier-debit-note/SupplierDebitNoteViewPage'))
);
const SupplierInvoiceCreatePage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/supplier-invoice/SupplierInvoiceCreatePage')));
const SupplierInvoiceEditPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/supplier-invoice/SupplierInvoiceEditPage')));
const SupplierInvoiceViewPage = Loadable(lazy(() => import('static-solutions/24155/identity-solution/supplier-invoice/SupplierInvoiceViewPage')));
const LandOneTimeActionCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-one-time-action-management/LandOneTimeActionCreatePage'))
);
const LandOneTimeActionEditPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-one-time-action-management/LandOneTimeActionEditPage'))
);
const LandOneTimeActionViewPage = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/land-one-time-action-management/LandOneTimeActionViewPage'))
);
const StaticGeneralLedgerCodeCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger-code/Create')));
const StaticGeneralLedgerCode = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger-code/Edit')));
const StaticGeneralLedgerCodeCreateV2 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger-code-v2/Create')));
const StaticGeneralLedgerCodeEditV2 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger-code-v2/Edit')));
const StaticCostCenterCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/cost-center/Create')));
const StaticCostCenterCreateV2 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/cost-center-v2/Create')));
const StaticCostCenter = Loadable(lazy(() => import('static-solutions/24155/identity-solution/cost-center/Edit')));
const StaticCostCenterV2 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/cost-center-v2/Edit')));
const StaticLeaseRecordManagementV4 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v4/Create')));
const StaticLeaseRecordManagementEditV4 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v4/Edit')));
const StaticLeaseRecordManagementCreationV5 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v5/Create'))
);
const StaticLeaseRecordManagementEditV5 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v5/Edit')));
const StaticLeaseRecordManagementViewV5 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v5/Create')));
const StaticLeaseRecordManagementReviseV5 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v5/Revise'))
);
const StaticLeaseRecordManagementReviseV6 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v6/Revise'))
);
const StaticLeaseRecordManagementReviseV7 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v7/Revise'))
);

//lease-test-bed
const StaticLeaseRecordManagementTestBedCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-test-bed/Create')));
const StaticLeaseRecordManagementTestBedDetails = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-test-bed/Create')));
const StaticLeaseRecordManagementTestBedEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-test-bed/Edit')));
// Add this if revise functionality is needed
const StaticLeaseRecordManagementTestBedRevise = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-test-bed/Revise')));
const StaticAccessControl = Loadable(lazy(() => import('static-solutions/24155/identity-solution/access-control/Create')));
const StaticDocumentGroup = Loadable(lazy(() => import('static-solutions/24155/identity-solution/document-group/Create')));
const StaticDocumentHierarchy = Loadable(lazy(() => import('static-solutions/24155/identity-solution/document-hierarchy/Create')));
const StaticDocumentUploader = Loadable(lazy(() => import('static-solutions/24155/identity-solution/document-uploader/Create')));
// const AttendancePolicyCreate = Loadable(lazy(() => import('static-solutions/24155/policy-solution/attendance/Create')));
const AccountsAssignmentPolicyCreate = Loadable(lazy(() => import('static-solutions/24155/policy-solution/accounts-assignment/Create')));
const AccountsAssignmentPolicy = Loadable(lazy(() => import('static-solutions/24155/policy-solution/accounts-assignment/Edit')));
const AccountsAssignmentPolicyCreateV2 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/accounts-assignment-v2/Create')));
const AccountsAssignmentPolicyEditV2 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/accounts-assignment-v2/Edit')));
const CostCenterPolicyCreate = Loadable(lazy(() => import('static-solutions/24155/policy-solution/cost-center-assignment/Create')));
const CostCenterPolicyCreateV2 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/cost-center-assignment-v2/Create')));
const CostCenterPolicy = Loadable(lazy(() => import('static-solutions/24155/policy-solution/cost-center-assignment/Edit')));
const CostCenterPolicyV2 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/cost-center-assignment-v2/Edit')));
const PerformanceParameterCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/performanceParameter/Create')));
const LeaseSecondConsoleV2 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v2/index')));
const LeaseSecondConsoleV4 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v4/index')));
const LeaseSecondConsoleV5 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v5/index')));
const LeaseSecondConsoleV6 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v6/index')));
const DecommissionAssetAccounting = Loadable(lazy(() => import('static-solutions/24155/console-solution/decommission-asset-accounting/index')));
const LeaseSecondConsoleV7 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v7/index')));
const ListViewPettyCashFloatConsole = Loadable(lazy(() => import('static-solutions/25118/console-solution/ListViewPettyCashFloatDashboard/index')));
const ListViewPettyCashReconciliationConsole = Loadable(
	lazy(() => import('static-solutions/25118/console-solution/ListViewPettyCashReconciliationDashboard/index'))
);
const ListViewPettyCashTransactionConsole = Loadable(
	lazy(() => import('static-solutions/25118/console-solution/ListViewPettyCashTransaction/index'))
);
const PettyCashTransactionForCasher = Loadable(
	lazy(() => import('static-solutions/25118/console-solution/ListViewPettyCashTransaction/ListViewPettyCashTransaction'))
);
const KpiConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/kpi-console')));
const TeamKpiEvaluationStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/team-kpi-evaluation')));
const SalaryManagementConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/salary-management')));
const LeadPipelineConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-pipeline')));
const LeadKanbanConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-kanban')));
const PreLitigationKanbanConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/pre-litigation-kanban')));
const LitigationKanbanConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/litigation-kanban')));
const LegalActionPerformanceManagerConsoleStatic = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/legal-action-performance-manager'))
);
const FundAllocationPlanWorkbench = Loadable(lazy(() => import('static-solutions/24155/console-solution/fund-allocation-plan-workbench')));
const FundAllocationPlanCreatePage = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/fund-allocation-plan-workbench/FundAllocationPlanCreatePage'))
);
const FundAllocationPlanEditPage = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/fund-allocation-plan-workbench/FundAllocationPlanEditPage'))
);
const FundAllocationPlanViewPage = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/fund-allocation-plan-workbench/FundAllocationPlanViewPage'))
);
const DonorCompanyDisbursementQueue = Loadable(lazy(() => import('static-solutions/24155/console-solution/donor-company-disbursement-queue')));
const DonorCompanyDisbursementQueueDetailPage = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/donor-company-disbursement-queue/DonorCompanyDisbursementQueueDetailPage'))
);
const LeadIngestionPoolConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-ingestion-pool')));
const LeadBackOfficeWorkbenchV2ConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-back-office-workbench-v2')));
const ScmBackOfficeWorkbenchConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/scm-back-office-workbench')));
const TechnicalEvaluationWorkbenchConsoleStatic = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/technical-evaluation-workbench'))
);
const TechnicalEvaluationWorkbenchDetailPage = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/technical-evaluation-workbench/TechnicalEvaluationWorkbenchDetailPage'))
);
const VendorRfqWorkbenchConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/vendor-rfq-workbench')));
const VendorRfqWorkbenchDetailPage = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/vendor-rfq-workbench/VendorRfqWorkbenchDetailPage'))
);
const InvoiceMatchingWorkbenchConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/invoice-matching-workbench')));
const InvoiceMatchingWorkbenchDetailPage = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/invoice-matching-workbench/InvoiceMatchingWorkbenchDetailPage'))
);
const ScmBuyerAssignmentConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/scm-buyer-assignment')));
const ScmKanbanConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/scm-kanban')));
const BuyerWorkbenchConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/buyer-workbench')));
const LeadScreeningConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-screening')));
const LeadAssignmentConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-assignment')));
const LeadWorkbenchConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-workbench')));
const PreLitigationWorkbenchConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/pre-litigation-workbench')));
const PreLitigationWorkbenchNewConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/pre-litigation-workbench-new')));
const LitigationWorkbenchConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/litigation-workbench')));
const StaticRosterShiftsPolicy = Loadable(lazy(() => import('static-solutions/24155/policy-solution/roster-shifts')));
const StaticRosterShiftsPolicyEdit = Loadable(lazy(() => import('static-solutions/24155/policy-solution/roster-shifts/Edit')));
const StaticRosterShiftsPolicyDetails = Loadable(lazy(() => import('static-solutions/24155/policy-solution/roster-shifts/Details')));

// KPI Components Import
const StaticKeyPerformanceIndicator = Loadable(lazy(() => import('static-solutions/24155/identity-solution/key-performance-indicator/Create')));
const StaticKpiEvolution = Loadable(lazy(() => import('static-solutions/24155/identity-solution/kpi-evaluation/Create')));

// DMS
// Vendor Invoice Submission.
const StaticVendorInvoiceSubmission = Loadable(lazy(() => import('static-solutions/24155/identity-solution/vendor-invoice-submission/Create')));
const StaticVendorInvoiceSubmissionViewAndEdit = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/vendor-invoice-submission/Details'))
);
// Invoice Command Center
const StaticInvoiceCommandCenter = Loadable(lazy(() => import('static-solutions/24155/identity-solution/invoice-command-center/Details')));
// Invoice AP Console
const StaticInvoiceAPConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/invoice-ap-console/Details')));
const InvoiceAPConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/invoice-ap-console/index')));
// Invoice Treasury Console
const StaticInvoiceTreasuryConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/invoice-treasury-console/Details')));
const InvoiceTreasuryConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/invoice-treasury-console/index')));

// Common Escalation Matrix
const StaticCommonEscalationMatrixCreate = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/common-escalation-matrix/CommonEscalationMatrixCreate'))
);
const StaticCommonEscalationMatrixEdit = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/common-escalation-matrix/CommonEscalationMatrixEdit'))
);
const ListViewFixedAssetRegisterConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/fixed-asset-register/index')));

/* ================================ Lease V9 Component Import Start ================================= */

const StaticLeaseRecordManagementDataTableV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-management-v9/index'))
);
const StaticLeaseRecordManagementV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-management-v9/Create'))
);
const StaticLeaseRecordManagementEditV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-management-v9/Edit'))
);
const StaticLeaseRecordEditListV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-edit-v9/index')));
const StaticLeaseRecordEditViewV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-edit-v9/Create')));
const StaticLeaseRecordEditV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-edit-v9/LeaseRecordEditPage'))
);
const StaticLeaseRecordModifyListV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-modify-v9/index')));
const StaticLeaseRecordModifyViewV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-modify-v9/Create')));
const StaticLeaseRecordModifyV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-modify-v9/LeaseRecordModifyPage'))
);
const StaticLeaseRecordManagementReviseV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-management-v9/Revise'))
);
const StaticGeneralLedgerCodeCreateV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/general-ledger-code-v9/Create'))
);
const StaticGeneralLedgerCodeEditV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/general-ledger-code-v9/Edit')));
const AccountsAssignmentPolicyCreateV9 = Loadable(
	lazy(() => import('static-solutions/24155/policy-solution/lease-v9/accounts-assignment-v9/Create'))
);
const AccountsAssignmentPolicyEditV9 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/lease-v9/accounts-assignment-v9/Edit')));
const StaticCostCenterCreateV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/cost-center-v9/Create')));
const StaticCostCenterV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/cost-center-v9/Edit')));
const CostCenterPolicyCreateV9 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/lease-v9/cost-center-assignment-v9/Create')));
const CostCenterPolicyV9 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/lease-v9/cost-center-assignment-v9/Edit')));
const StaticLeaseAgreementV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-agreement-v9/Create')));
const StaticLeaseAgreementDetailsV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-agreement-v9/Details')));
const StaticLeaseAgreementEditV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-agreement-v9/Edit')));
const StaticLeaseRecordSimulatorV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-simulator-v9/CreateNew')));
// Add this if revise functionality is needed
const StaticLeaseRecordManagementTestBedReviseV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-test-bed-v9/Revise'))
);
const LeaseSecondConsoleV9 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-v9/lease-schedule-v9/index')));
const LeaseAccountingV10 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-v9/lease-accounting-v10/index')));
const StaticGeneralLedgerCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger/Create')));
const StaticGeneralLedgerView = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger/Edit')));
const StaticGeneralLedgerEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger/Edit')));
const StaticLeasePayableV9Console = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-v9/lease-payable-v9/LeasePayableV9')));
const StaticLeasePayableApprovalV9Console = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/lease-v9/lease-payable-approval-v9/LeasePayableApprovalV9'))
);
const StaticTaxPayableConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/tax-payable/TaxPayable')));
const StaticAssetMasterDataCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/asset-master-data/Create')));
const StaticAssetMasterDataView = Loadable(lazy(() => import('static-solutions/24155/identity-solution/asset-master-data/Edit')));
const StaticProcessGroupRoleCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/process-group-roles/Create')));
const ActingPositionOverview = Loadable(lazy(() => import('static-solutions/24155/console-solution/acting-position-overview/index')));
const RateAgreement = Loadable(lazy(() => import('static-solutions/24155/console-solution/rate-agreement/index')));
const ProjectMilestone = Loadable(lazy(() => import('static-solutions/24155/console-solution/project-milestone/index')));
const RentalSubscription = Loadable(lazy(() => import('static-solutions/24155/console-solution/rental-subscription/index')));
const ConsolidatedContractAdministration = Loadable(lazy(() => import('static-solutions/24155/console-solution/contract-administration/index')));
const LeadConfigurationIndex = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-configuration/index')));
const LeadConfigurationCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-configuration/Create')));
const LeadConfigurationEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-configuration/Edit')));
const LeadExitRepositoryCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-exit-repository/Create')));
const LeadExitRepositoryEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-exit-repository/Edit')));
const JobAdvertisementIndex = Loadable(lazy(() => import('static-solutions/24155/identity-solution/job-advertisement/index')));
const JobAdvertisementCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/job-advertisement/Create')));
const JobAdvertisementEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/job-advertisement/Edit')));

/* ================================ Lease V9 Component Import End ================================= */

const StaticSolutionRoutes = [
	{
		path: 'static',
		children: [
			{
				path: 'employee',
				children: [
					{
						index: true,
						element: <StaticEmployeeMaster />,
					},
					{
						path: ':id',
						element: <StaticEmployeeMaster />,
					},
					{
						path: 'create',
						element: <StaticCOEEmployeeMaster />,
					},
					{
						path: 'edit',
						element: <StaticCOEEmployeeMaster />,
					},
					{
						path: 'details',
						element: <StaticDetailsEmployeeMaster />,
					},
				],
			},
			{
				path: 'process-role',
				children: [
					{
						index: true,
						element: <StaticProcessRoleMaster />,
					},
					{
						path: ':id',
						element: <StaticProcessRoleMaster />,
					},
					{
						path: 'create',
						element: <StaticProcessRoleCreate />,
					},
					{
						path: 'edit',
						element: <StaticProcessRoleEdit />,
					},
					{
						path: 'details',
						element: <StaticProcessRoleDetails />,
					},
				],
			},
			{
				path: 'committee',
				children: [
					{
						index: true,
						element: <StaticCommittee />,
					},
					{
						path: ':id',
						element: <StaticCommittee />,
					},
					{
						path: 'create',
						element: <StaticCOECommittee />,
					},
					{
						path: 'edit',
						element: <StaticCommitteeEdit screen="edit" />,
					},
					{
						path: 'details',
						element: <StaticCommitteeEdit screen="view" />,
					},
				],
			},
			{
				path: 'lead-configuration',
				children: [
					{
						index: true,
						element: <LeadConfigurationIndex />,
					},
					{
						path: ':id',
						element: <LeadConfigurationIndex />,
					},
					{
						path: 'create',
						element: <LeadConfigurationCreate />,
					},
					{
						path: 'edit',
						element: <LeadConfigurationEdit screen="edit" />,
					},
					{
						path: 'details',
						element: <LeadConfigurationEdit screen="view" />,
					},
				],
			},
			{
				path: 'lead-stage-sla-profiles',
				children: [
					{
						path: 'create',
						element: <LeadStageSlaProfilesCreatePage />,
					},
					{
						path: 'edit',
						element: <LeadStageSlaProfilesEditPage />,
					},
					{
						path: 'details',
						element: <LeadStageSlaProfilesViewPage />,
					},
				],
			},
			{
				path: 'procurement-progression-profile',
				children: [
					{
						path: 'create',
						element: <ProcurementProgressionProfileCreatePage />,
					},
					{
						path: 'edit',
						element: <ProcurementProgressionProfileEditPage />,
					},
					{
						path: 'details',
						element: <ProcurementProgressionProfileViewPage />,
					},
				],
			},
			{
				path: 'pre-litigation-lifecycle-effort-profile',
				children: [
					{
						path: 'create',
						element: <PreLitigationLifecycleEffortProfileCreatePage />,
					},
					{
						path: 'edit',
						element: <PreLitigationLifecycleEffortProfileEditPage />,
					},
					{
						path: 'details',
						element: <PreLitigationLifecycleEffortProfileViewPage />,
					},
				],
			},
			{
				path: 'recruitment-lifecycle-effort-profile',
				children: [
					{
						path: 'create',
						element: <RecruitmentLifecycleEffortProfileCreatePage />,
					},
					{
						path: 'edit',
						element: <RecruitmentLifecycleEffortProfileEditPage />,
					},
					{
						path: 'details',
						element: <RecruitmentLifecycleEffortProfileViewPage />,
					},
				],
			},
			{
				path: 'litigation-lifecycle-effort-profile',
				children: [
					{
						path: 'create',
						element: <LitigationLifecycleEffortProfileCreatePage />,
					},
					{
						path: 'edit',
						element: <LitigationLifecycleEffortProfileEditPage />,
					},
					{
						path: 'details',
						element: <LitigationLifecycleEffortProfileViewPage />,
					},
				],
			},
			{
				path: 'lead-exit-repository',
				children: [
					{
						path: 'create',
						element: <LeadExitRepositoryCreate />,
					},
					{
						path: 'edit',
						element: <LeadExitRepositoryEdit screen="edit" />,
					},
					{
						path: 'details',
						element: <LeadExitRepositoryEdit screen="view" />,
					},
				],
			},
			{
				path: 'job-advertisement',
				children: [
					{
						index: true,
						element: <JobAdvertisementIndex />,
					},
					{
						path: ':id',
						element: <JobAdvertisementIndex />,
					},
					{
						path: 'create',
						element: <JobAdvertisementCreate />,
					},
					{
						path: 'edit',
						element: <JobAdvertisementEdit screen="edit" />,
					},
					{
						path: 'details',
						element: <JobAdvertisementEdit screen="view" />,
					},
				],
			},
			{
				path: 'key-management-area',
			},
			{
				path: 'float-creation',
				children: [
					{
						path: 'create',
						element: <StaticFloatCreationCreate />,
					},
				],
			},
			{
				path: 'control-questionnaire',
				children: [
					{
						path: 'create',
						element: <StaticControlQuestionnaire />,
					},
				],
			},
			{
				path: 'assign-control-questionnaire',
				children: [
					{
						path: 'create',
						element: <StaticAssignControlQuestionnaire />,
					},
				],
			},
			{
				path: 'lease-record-management',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagement screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagement screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEdit />,
					},
				],
			},
			{
				path: 'lease-record-management-v2',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV2 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementV2 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV2 />,
					},
				],
			},
			{
				path: 'lease-record-management-v6',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordManagementDataTableV6 />,
					},
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV6 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementV6 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV6 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementReviseV6 screen="REVISE" />,
					},
				],
			},
			{
				path: 'decommission-asset',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordManagementDecommissionAssetV6 />,
					},
					{
						path: 'create',
						element: <StaticDecommissionAssetV6 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticDecommissionAssetV6 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticDecommissionAssetEditV6 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticDecommissionAssetReviseV6 screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-record-management-v7',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV7 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementV7 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV7 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementReviseV7 screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-record-management-v4',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV4 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementV4 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV4 />,
					},
				],
			},
			{
				path: 'lease-record-management-v5',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementCreationV5 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementViewV5 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV5 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementReviseV5 screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-simulator',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordSimulator />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordSimulator screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordSimulator screen="EDIT" />,
					},
				],
			},
			{
				path: 'lease-test-bed',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementTestBedCreate screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementTestBedDetails screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementTestBedEdit screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementTestBedRevise screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-agreement',
				children: [
					{
						path: 'create',
						element: <StaticLeaseAgreement />,
					},
					{
						path: 'details',
						element: <StaticLeaseAgreementDetails />,
					},
					{
						path: 'edit',
						element: <StaticLeaseAgreementEdit screen="EDIT" />,
					},
				],
			},
			{
				path: 'task-attachment',
				children: [
					{
						path: 'create',
						element: <StaticTaskAttachment />,
					},
					{
						path: 'details',
						element: <StaticTaskAttachmentEditAndDetails screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticTaskAttachmentEditAndDetails screen="EDIT" />,
					},
				],
			},
			{
				path: 'ocr-ai-solution',
				children: [
					{
						index: true,
						element: <StaticOcrAiSolution />,
					},
					{
						path: ':id',
						element: <StaticOcrAiSolution />,
					},
					{
						path: 'create',
						element: <StaticOcrAiSolution screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticOcrAiSolution screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticOcrAiSolution screen="EDIT" />,
					},
				],
			},
			{
				path: 'electricity-bill-upload',
				children: [
					{
						index: true,
						element: <StaticElectricityBillUpload />,
					},
					{
						path: ':id',
						element: <StaticElectricityBillUpload />,
					},
					{
						path: 'create',
						element: <StaticElectricityBillUpload screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticElectricityBillUpload screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticElectricityBillUpload screen="EDIT" />,
					},
				],
			},
			{
				path: 'general-ledger-code',
				children: [
					{
						path: 'create',
						element: <StaticGeneralLedgerCodeCreate />,
					},
					{
						path: 'details',
						element: <StaticGeneralLedgerCode screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticGeneralLedgerCode screen="EDIT" />,
					},
				],
			},
			{
				path: 'general-ledger-code-v2',
				children: [
					{
						path: 'create',
						element: <StaticGeneralLedgerCodeCreateV2 />,
					},
					{
						path: 'details',
						element: <StaticGeneralLedgerCodeEditV2 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticGeneralLedgerCodeEditV2 screen="EDIT" />,
					},
				],
			},
			{
				path: 'cost-center',
				children: [
					{
						path: 'create',
						element: <StaticCostCenterCreate />,
					},
					{
						path: 'details',
						element: <StaticCostCenter screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticCostCenter screen="EDIT" />,
					},
				],
			},
			{
				path: 'cost-center-v2',
				children: [
					{
						path: 'create',
						element: <StaticCostCenterCreateV2 />,
					},
					{
						path: 'details',
						element: <StaticCostCenterV2 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticCostCenterV2 screen="EDIT" />,
					},
				],
			},
			{
				path: 'control-testing',
				children: [
					{
						path: 'create',
						element: <StaticControlTesting />,
					},
				],
			},
			{
				path: 'assign-control-self-assurance',
				children: [
					{
						path: 'create',
						element: <AssignControlSelfAssurance />,
					},
				],
			},
			{
				path: 'assign-control-self-assurance-v2',
				children: [
					{
						path: 'create',
						element: <AssignControlSelfAssuranceV2 />,
					},
				],
			},
			{
				path: 'leave-policy',
				children: [
					{
						path: 'create',
						element: <StaticAnnualLeaveCreate />,
					},
				],
			},
			{
				path: 'leave-combine',
				children: [
					{
						index: true,
						path: ':id',
						element: <CombinedLeaveListPage />,
					},
					{
						path: 'create',
						element: <StaticLeave />,
					},
					{
						path: 'details',
						element: <StaticLeaveUpdate screen="VIEW" />,
					},
					{
						path: 'update',
						element: <StaticLeaveUpdate screen="EDIT" />,
					},
					{
						path: 'policy',
						element: <StaticLeaveDetails />,
					},
				],
			},
			{
				path: 'leave-management',
				children: [
					{
						path: ':id',
						element: <LeaveManagement />,
					},
				],
			},
			{
				path: 'raw-sourcing-request',
				children: [
					{
						path: 'create',
						element: <RawSourcingRequestCreatePage />,
					},
					{
						path: 'details',
						element: <RawSourcingRequestViewPage />,
					},
					{
						path: 'edit',
						element: <RawSourcingRequestEditPage />,
					},
				],
			},
			{
				path: 'rfq-strategy-planning-entry',
				children: [
					{
						path: 'create',
						element: <RfqStrategyPlanningEntryCreatePage />,
					},
					{
						path: 'details',
						element: <RfqStrategyPlanningEntryViewPage />,
					},
					{
						path: 'edit',
						element: <RfqStrategyPlanningEntryEditPage />,
					},
				],
			},
			{
				path: 'rfq-package-finalization',
				children: [
					{
						path: 'create',
						element: <RfqPackageFinalizationCreatePage />,
					},
					{
						path: 'details',
						element: <RfqPackageFinalizationViewPage />,
					},
					{
						path: 'edit',
						element: <RfqPackageFinalizationEditPage />,
					},
				],
			},
			{
				path: 'payment-terms-master',
				children: [
					{
						index: true,
						element: <PaymentTermsMasterList />,
					},
					{
						path: ':id',
						element: <PaymentTermsMasterList />,
					},
					{
						path: 'create',
						element: <PaymentTermsMasterCreatePage />,
					},
					{
						path: 'details',
						element: <PaymentTermsMasterViewPage />,
					},
					{
						path: 'edit',
						element: <PaymentTermsMasterEditPage />,
					},
				],
			},
			{
				path: 'purchase-requisition',
				children: [
					{
						index: true,
						element: <PurchaseRequisitionCreatePage />,
					},
					{
						path: ':id',
						element: <PurchaseRequisitionCreatePage />,
					},
					{
						path: 'create',
						element: <PurchaseRequisitionCreatePage />,
					},
					{
						path: 'details',
						element: <PurchaseRequisitionViewPage />,
					},
					{
						path: 'edit',
						element: <PurchaseRequisitionEditPage />,
					},
				],
			},
			{
				path: 'supplier-debit-note',
				children: [
					{
						index: true,
						element: <SupplierDebitNoteCreatePage />,
					},
					{
						path: ':id',
						element: <SupplierDebitNoteCreatePage />,
					},
					{
						path: 'create',
						element: <SupplierDebitNoteCreatePage />,
					},
					{
						path: 'details',
						element: <SupplierDebitNoteViewPage />,
					},
					{
						path: 'edit',
						element: <SupplierDebitNoteEditPage />,
					},
				],
			},
			{
				path: 'supplier-invoice',
				children: [
					{
						index: true,
						element: <SupplierInvoiceCreatePage />,
					},
					{
						path: ':id',
						element: <SupplierInvoiceCreatePage />,
					},
					{
						path: 'create',
						element: <SupplierInvoiceCreatePage />,
					},
					{
						path: 'details',
						element: <SupplierInvoiceViewPage />,
					},
					{
						path: 'edit',
						element: <SupplierInvoiceEditPage />,
					},
				],
			},
			{
				path: 'sourcing-request-pool',
				children: [
					{
						index: true,
						element: <SourcingRequestPoolParallelList />,
					},
					{
						path: ':id',
						element: <SourcingRequestPoolParallelList />,
					},
					{
						path: 'create',
						element: <SourcingRequestPoolParallelCreatePage />,
					},
					{
						path: 'details',
						element: <SourcingRequestPoolParallelDetailsPage />,
					},
					{
						path: 'edit',
						element: <SourcingRequestPoolParallelEditPage />,
					},
				],
			},
			{
				path: 'raw-lead-records',
				children: [
					{
						path: ':id',
						element: <LeadCreationList />,
					},
					{
						path: 'create',
						element: <LeadCreationCreatePage />,
					},
					{
						path: 'details',
						element: <LeadCreationViewPage />,
					},
					{
						path: 'edit',
						element: <LeadCreationEditPage />,
					},
				],
			},
			{
				path: 'land-record',
				children: [
					{
						path: ':id',
						element: <LandRecordList />,
					},
					{
						path: 'create',
						element: <LandRecordCreatePage />,
					},
					{
						path: 'details',
						element: <LandRecordViewPage />,
					},
					{
						path: 'edit',
						element: <LandRecordEditPage />,
					},
				],
			},
			{
				path: 'land-document-management',
				children: [
					{
						path: 'create',
						element: <LandDocumentManagementCreatePage />,
					},
					{
						path: 'details',
						element: <LandDocumentManagementViewPage />,
					},
					{
						path: 'edit',
						element: <LandDocumentManagementEditPage />,
					},
				],
			},
			{
				path: 'convert-pre-litigation-to-litigation-case',
				children: [
					{
						path: ':id',
						element: <ConvertPreLitigationToLitigationCaseList />,
					},
					{
						path: 'create',
						element: <ConvertPreLitigationToLitigationCaseCreatePage />,
					},
					{
						path: 'details',
						element: <ConvertPreLitigationToLitigationCaseViewPage />,
					},
					{
						path: 'edit',
						element: <ConvertPreLitigationToLitigationCaseEditPage />,
					},
				],
			},
			{
				path: 'pre-litigation-matter-registration',
				children: [
					{
						path: ':id',
						element: <PreLitigationMatterRegistrationList />,
					},
					{
						path: 'create',
						element: <PreLitigationMatterRegistrationCreatePage />,
					},
					{
						path: 'details',
						element: <PreLitigationMatterRegistrationViewPage />,
					},
					{
						path: 'edit',
						element: <PreLitigationMatterRegistrationEditPage />,
					},
				],
			},
			{
				path: 'law-firm-record-entry',
				children: [
					{
						path: ':id',
						element: <LawFirmRecordEntryList />,
					},
					{
						path: 'create',
						element: <LawFirmRecordEntryCreatePage />,
					},
					{
						path: 'details',
						element: <LawFirmRecordEntryViewPage />,
					},
					{
						path: 'edit',
						element: <LawFirmRecordEntryEditPage />,
					},
				],
			},
			{
				path: 'land-recurring-action-management',
				children: [
					{
						path: ':id',
						element: <LandRecurringActionManagementList />,
					},
					{
						path: 'create',
						element: <LandRecurringActionManagementCreatePage />,
					},
					{
						path: 'details',
						element: <LandRecurringActionManagementViewPage />,
					},
					{
						path: 'edit',
						element: <LandRecurringActionManagementEditPage />,
					},
				],
			},
			{
				path: 'lawer-record-entry',
				children: [
					{
						path: ':id',
						element: <LawerRecordEntryList />,
					},
					{
						path: 'create',
						element: <LawerRecordEntryCreatePage />,
					},
					{
						path: 'details',
						element: <LawerRecordEntryViewPage />,
					},
					{
						path: 'edit',
						element: <LawerRecordEntryEditPage />,
					},
				],
			},
			{
				path: 'hearing-schedule',
				children: [
					{
						path: 'create',
						element: <HearingScheduleCreatePage />,
					},
					{
						path: 'details',
						element: <HearingScheduleViewPage />,
					},
					{
						path: 'edit',
						element: <HearingScheduleEditPage />,
					},
				],
			},
			{
				path: 'vendor-registration-request',
				children: [
					{
						path: ':id',
						element: <VendorRegistrationRequestList />,
					},
					{
						path: 'create',
						element: <VendorRegistrationRequestCreatePage />,
					},
					{
						path: 'details',
						element: <VendorRegistrationRequestViewPage />,
					},
					{
						path: 'edit',
						element: <VendorRegistrationRequestEditPage />,
					},
				],
			},
			{
				path: 'vendor-registration-multi-form',
				children: [
					{
						path: 'create',
						element: <VendorRegistrationMultiFormCreatePage />,
					},
					{
						path: 'details',
						element: <VendorRegistrationMultiFormViewPage />,
					},
					{
						path: 'edit',
						element: <VendorRegistrationMultiFormEditPage />,
					},
				],
			},
			{
				path: 'business-case',
				children: [
					{
						index: true,
						element: <BusinessCaseList />,
					},
					{
						path: ':id',
						element: <BusinessCaseList />,
					},
					{
						path: 'create',
						element: <BusinessCaseCreatePage />,
					},
					{
						path: 'details',
						element: <BusinessCaseViewPage />,
					},
					{
						path: 'edit',
						element: <BusinessCaseEditPage />,
					},
				],
			},
			{
				path: 'bank-account-master',
				children: [
					{
						index: true,
						element: <BankAccountMasterList />,
					},
					{
						path: ':id',
						element: <BankAccountMasterList />,
					},
					{
						path: 'create',
						element: <BankAccountMasterCreatePage />,
					},
					{
						path: 'details',
						element: <BankAccountMasterViewPage />,
					},
					{
						path: 'edit',
						element: <BankAccountMasterEditPage />,
					},
				],
			},
			{
				path: 'intercompany-fund-request',
				children: [
					{
						index: true,
						element: <IntercompanyFundRequestList />,
					},
					{
						path: ':id',
						element: <IntercompanyFundRequestList />,
					},
					{
						path: 'create',
						element: <IntercompanyFundRequestCreatePage />,
					},
					{
						path: 'details',
						element: <IntercompanyFundRequestViewPage />,
					},
					{
						path: 'edit',
						element: <IntercompanyFundRequestEditPage />,
					},
				],
			},
			{
				path: 'donor-allocation',
				children: [
					{
						index: true,
						element: <DonorAllocationChildList />,
					},
					{
						path: ':id',
						element: <DonorAllocationChildList />,
					},
					{
						path: 'create',
						element: <DonorAllocationChildCreatePage />,
					},
					{
						path: 'details',
						element: <DonorAllocationChildViewPage />,
					},
					{
						path: 'edit',
						element: <DonorAllocationChildEditPage />,
					},
				],
			},
			{
				path: 'disbursement-case-approval',
				children: [
					{
						index: true,
						element: <DisbursementCaseApprovalList />,
					},
					{
						path: ':id',
						element: <DisbursementCaseApprovalList />,
					},
					{
						path: 'details',
						element: <DisbursementCaseApprovalViewPage />,
					},
				],
			},
			{
				path: 'purcase-order',
				children: [
					{
						path: 'create',
						element: <PurchaseOrderCreatePage />,
					},
					{
						path: 'details',
						element: <PurchaseOrderViewPage />,
					},
					{
						path: 'edit',
						element: <PurchaseOrderEditPage />,
					},
				],
			},
			{
				path: 'inventory-transaction',
				children: [
					{
						index: true,
						element: <InventoryTransactionCreatePage />,
					},
					{
						path: ':id',
						element: <InventoryTransactionCreatePage />,
					},
					{
						path: 'create',
						element: <InventoryTransactionCreatePage />,
					},
					{
						path: 'details',
						element: <InventoryTransactionViewPage />,
					},
					{
						path: 'edit',
						element: <InventoryTransactionEditPage />,
					},
				],
			},
			{
				path: 'data-privacy-assessment',
				children: [
					{
						index: true,
						element: <DataPrivacyAssessmentCreatePage />,
					},
					{
						path: ':id',
						element: <DataPrivacyAssessmentCreatePage />,
					},
					{
						path: 'create',
						element: <DataPrivacyAssessmentCreatePage />,
					},
					{
						path: 'details',
						element: <DataPrivacyAssessmentViewPage />,
					},
					{
						path: 'edit',
						element: <DataPrivacyAssessmentEditPage />,
					},
				],
			},
			{
				path: 'health-safety-environment-check',
				children: [
					{
						index: true,
						element: <HealthSafetyEnvironmentCheckCreatePage />,
					},
					{
						path: ':id',
						element: <HealthSafetyEnvironmentCheckCreatePage />,
					},
					{
						path: 'create',
						element: <HealthSafetyEnvironmentCheckCreatePage />,
					},
					{
						path: 'details',
						element: <HealthSafetyEnvironmentCheckViewPage />,
					},
					{
						path: 'edit',
						element: <HealthSafetyEnvironmentCheckEditPage />,
					},
				],
			},
			{
				path: 'service-receipt',
				children: [
					{
						path: 'create',
						element: <ServiceReceiptCreatePage />,
					},
					{
						path: 'details',
						element: <ServiceReceiptViewPage />,
					},
					{
						path: 'edit',
						element: <ServiceReceiptEditPage />,
					},
				],
			},
			{
				path: 'inventory-transfer',
				children: [
					{
						index: true,
						element: <InventoryTransferCreatePage />,
					},
					{
						path: ':id',
						element: <InventoryTransferCreatePage />,
					},
					{
						path: 'create',
						element: <InventoryTransferCreatePage />,
					},
					{
						path: 'details',
						element: <InventoryTransferViewPage />,
					},
					{
						path: 'edit',
						element: <InventoryTransferEditPage />,
					},
				],
			},
			{
				path: 'goods-receipt',
				children: [
					{
						path: 'create',
						element: <GoodsReceiptCreatePage />,
					},
					{
						path: 'details',
						element: <GoodsReceiptViewPage />,
					},
					{
						path: 'edit',
						element: <GoodsReceiptEditPage />,
					},
				],
			},
			{
				path: 'legal-expense-provision',
				children: [
					{
						path: 'create',
						element: <LegalExpenseProvisionCreatePage />,
					},
					{
						path: 'details',
						element: <LegalExpenseProvisionViewPage />,
					},
					{
						path: 'edit',
						element: <LegalExpenseProvisionEditPage />,
					},
				],
			},
			{
				path: 'position-request',
				children: [
					{
						path: 'create',
						element: <PositionRequestCreatePage />,
					},
					{
						path: 'details',
						element: <PositionRequestViewPage />,
					},
					{
						path: 'edit',
						element: <PositionRequestEditPage />,
					},
				],
			},
			{
				path: 'hiring-request',
				children: [
					{
						path: 'create',
						element: <HiringRequestCreatePage />,
					},
					{
						path: 'details',
						element: <HiringRequestViewPage />,
					},
					{
						path: 'edit',
						element: <HiringRequestEditPage />,
					},
				],
			},
			{
				path: 'identity-and-legal-validation',
				children: [
					{
						path: 'details',
						element: <IdentityLegalValidationViewPage />,
					},
					{
						path: 'edit',
						element: <IdentityLegalValidationEditPage />,
					},
				],
			},
			{
				path: 'address-and-contact',
				children: [
					{
						path: 'details',
						element: <AddressContactViewPage />,
					},
					{
						path: 'edit',
						element: <AddressContactEditPage />,
					},
				],
			},
			{
				path: 'bank-and-payment-information',
				children: [
					{
						path: 'details',
						element: <BankPaymentInformationViewPage />,
					},
					{
						path: 'edit',
						element: <BankPaymentInformationEditPage />,
					},
				],
			},
			{
				path: 'commercial-and-procurement-setup',
				children: [
					{
						path: 'details',
						element: <CommercialProcurementSetupViewPage />,
					},
					{
						path: 'edit',
						element: <CommercialProcurementSetupEditPage />,
					},
				],
			},
			{
				path: 'compliance-declaration-and-risk',
				children: [
					{
						path: 'details',
						element: <ComplianceDeclarationRiskViewPage />,
					},
					{
						path: 'edit',
						element: <ComplianceDeclarationRiskEditPage />,
					},
				],
			},
			{
				path: 'bid-submission',
				children: [
					{
						path: ':id',
						element: <BidSubmissionList />,
					},
					{
						path: 'create',
						element: <BidSubmissionCreatePage />,
					},
					{
						path: 'details',
						element: <BidSubmissionViewPage />,
					},
					{
						path: 'edit',
						element: <BidSubmissionEditPage />,
					},
				],
			},
			{
				path: 'technical-evaluation-criteria-configuration',
				children: [
					{
						path: 'create',
						element: <TechnicalEvaluationCriteriaConfigurationCreatePage />,
					},
					{
						path: 'details',
						element: <TechnicalEvaluationCriteriaConfigurationViewPage />,
					},
					{
						path: 'edit',
						element: <TechnicalEvaluationCriteriaConfigurationEditPage />,
					},
				],
			},
			{
				path: 'land-one-time-action-management',
				children: [
					{
						path: 'create',
						element: <LandOneTimeActionCreatePage />,
					},
					{
						path: 'details',
						element: <LandOneTimeActionViewPage />,
					},
					{
						path: 'edit',
						element: <LandOneTimeActionEditPage />,
					},
				],
			},
			{
				path: 'attendance-shift',
				children: [
					{
						path: 'create',
						element: <StaticAttendanceShiftCreate />,
					},
				],
			},
			{
				path: 'roster-shifts',
				children: [
					{
						index: true,
						element: <StaticRosterShiftsPolicy />,
					},
					{
						path: ':id',
						element: <StaticRosterShiftsPolicy />,
					},
					{
						path: 'create',
						element: <StaticRosterShiftsPolicy />,
					},
					{
						path: 'details',
						element: <StaticRosterShiftsPolicyDetails />,
					},
					{
						path: 'edit',
						element: <StaticRosterShiftsPolicyEdit />,
					},
				],
			},
			// {
			// 	path: 'shift-assignment',
			// 	children: [
			// 		{
			// 			path: 'create',
			// 			element: <AttendancePolicyCreate />,
			// 		},
			// 	],
			// },
			{
				path: 'accounts-assignment',
				children: [
					{
						path: 'create',
						element: <AccountsAssignmentPolicyCreate />,
					},
					{
						path: 'edit',
						element: <AccountsAssignmentPolicy screen="EDIT" />,
					},
					{
						path: 'details',
						element: <AccountsAssignmentPolicy screen="VIEW" />,
					},
				],
			},
			{
				path: 'accounts-assignment-v2',
				children: [
					{
						path: 'create',
						element: <AccountsAssignmentPolicyCreateV2 />,
					},
					{
						path: 'edit',
						element: <AccountsAssignmentPolicyEditV2 />,
					},
					{
						path: 'details',
						element: <AccountsAssignmentPolicyEditV2 />,
					},
				],
			},
			{
				path: 'cost-center-assignment',
				children: [
					{
						path: 'create',
						element: <CostCenterPolicyCreate />,
					},
					{
						path: 'edit',
						element: <CostCenterPolicy screen="EDIT" />,
					},
					{
						path: 'details',
						element: <CostCenterPolicy screen="VIEW" />,
					},
				],
			},
			{
				path: 'cost-center-assignment-v2',
				children: [
					{
						path: 'create',
						element: <CostCenterPolicyCreateV2 />,
					},
					{
						path: 'edit',
						element: <CostCenterPolicyV2 screen="EDIT" />,
					},
					{
						path: 'details',
						element: <CostCenterPolicyV2 screen="VIEW" />,
					},
				],
			},
			{
				path: 'access-control',
				children: [
					{
						path: 'create',
						element: <StaticAccessControl />,
					},
				],
			},
			{
				path: 'document-group',
				children: [
					{
						path: 'create',
						element: <StaticDocumentGroup />,
					},
				],
			},
			{
				path: 'document-hierarchy',
				children: [
					{
						path: 'create',
						element: <StaticDocumentHierarchy />,
					},
					{
						path: 'details',
						element: <StaticDocumentHierarchy screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticDocumentHierarchy screen="EDIT" />,
					},
				],
			},
			{
				path: 'file-upload',
				children: [
					{
						path: 'create',
						element: <StaticDocumentUploader />,
					},
					{
						path: 'details',
						element: <StaticDocumentUploader screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticDocumentUploader screen="EDIT" />,
					},
				],
			},
			{
				path: 'key-performance-indicator',
				children: [
					{
						path: 'create',
						element: <StaticKeyPerformanceIndicator />,
					},
					{
						path: 'details',
						element: <StaticKeyPerformanceIndicator screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticKeyPerformanceIndicator screen="EDIT" />,
					},
				],
			},
			{
				path: 'kpi-evaluation',
				children: [
					{
						path: 'create',
						element: <StaticKpiEvolution />,
					},
					{
						path: 'details',
						element: <StaticKpiEvolution screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticKpiEvolution screen="EDIT" />,
					},
				],
			},
			{
				path: 'compliance-action',
			},
			{
				path: 'vendor-invoice-submission',
				children: [
					{
						path: 'create',
						element: <StaticVendorInvoiceSubmission />,
					},
					{
						path: 'details',
						element: <StaticVendorInvoiceSubmissionViewAndEdit screen="VIEW" />,
					},
				],
			},
			{
				path: 'invoice-command-center',
				children: [
					{
						path: 'details',
						element: <StaticInvoiceCommandCenter screen="VIEW" />,
					},
				],
			},
			{
				path: 'common-escalation-matrix',
				children: [
					{
						path: 'create',
						element: <StaticCommonEscalationMatrixCreate />,
					},
					{
						path: 'edit',
						element: <StaticCommonEscalationMatrixEdit screen="EDIT" />,
					},
					{
						path: 'details',
						element: <StaticCommonEscalationMatrixEdit screen="VIEW" />,
					},
				],
			},
			{
				path: 'performance-parameter',
				children: [
					{
						path: 'create',
						element: <PerformanceParameterCreate />,
					},
				],
			},
			{
				path: 'lease-record-management-v9',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordManagementDataTableV9 />,
					},
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV9 screen="CREATE" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV9 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementReviseV9 screen="REVISE" />,
					},
					{
						path: 'edit-new-version',
						element: <LeaseRecordManagementV9Edit />,
					},
					{
						path: 'modify-new-version',
						element: <LeaseRecordManagementV9Modify />,
					},
					{
						path: 'details',
						element: <LeaseRecordManagementV9Details screen="VIEW" />,
					},
				],
			},
			{
				path: 'lease-record-edit-v9',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordEditListV9 />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordEditViewV9 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordEditV9 screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-record-modify-v9',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordModifyListV9 />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordModifyViewV9 screen="VIEW" />,
					},
					{
						path: 'modify',
						element: <StaticLeaseRecordModifyV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'general-ledger-code-v9',
				children: [
					{
						path: 'create',
						element: <StaticGeneralLedgerCodeCreateV9 />,
					},
					{
						path: 'details',
						element: <StaticGeneralLedgerCodeEditV9 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticGeneralLedgerCodeEditV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'accounts-assignment-v9',
				children: [
					{
						path: 'create',
						element: <AccountsAssignmentPolicyCreateV9 />,
					},
					{
						path: 'edit',
						element: <AccountsAssignmentPolicyEditV9 screen="EDIT" />,
					},
					{
						path: 'details',
						element: <AccountsAssignmentPolicyEditV9 screen="VIEW" />,
					},
				],
			},
			{
				path: 'cost-center-v9',
				children: [
					{
						path: 'create',
						element: <StaticCostCenterCreateV9 />,
					},
					{
						path: 'details',
						element: <StaticCostCenterV9 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticCostCenterV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'cost-center-assignment-v9',
				children: [
					{
						path: 'create',
						element: <CostCenterPolicyCreateV9 />,
					},
					{
						path: 'edit',
						element: <CostCenterPolicyV9 screen="EDIT" />,
					},
					{
						path: 'details',
						element: <CostCenterPolicyV9 screen="VIEW" />,
					},
				],
			},
			{
				path: 'lease-agreement-v9',
				children: [
					{
						path: 'create',
						element: <StaticLeaseAgreementV9 />,
					},
					{
						path: 'details',
						element: <StaticLeaseAgreementDetailsV9 />,
					},
					{
						path: 'edit',
						element: <StaticLeaseAgreementEditV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'lease-simulator-v9',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordSimulatorV9 />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordSimulatorV9 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordSimulatorV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'lease-test-bed-v9',
				children: [
					{
						path: 'create',
						element: <LeaseTrailModeV9NewCreate />,
					},
					{
						path: 'details',
						element: <LeaseV9NewTrailModeView />,
					},
					{
						path: 'edit',
						element: <LeaseV9NewTrailModeModify screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementTestBedReviseV9 screen="REVISE" />,
					},
				],
			},
			{
				path: 'chart-of-accounts',
				children: [
					{
						path: 'create',
						element: <StaticGeneralLedgerCreate />,
					},
					{
						path: 'details',
						element: <StaticGeneralLedgerView screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticGeneralLedgerEdit screen="EDIT" />,
					},
				],
			},
			{
				path: 'asset-master-data',
				children: [
					{
						path: 'create',
						element: <StaticAssetMasterDataCreate />,
					},
					{
						path: 'details',
						element: <StaticAssetMasterDataView screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticAssetMasterDataView screen="EDIT" />,
					},
				],
			},
			{
				path: 'process-group-roles',
				children: [
					{
						path: 'create',
						element: <StaticProcessGroupRoleCreate />,
					},
				],
			},
			{
				path: 'control/:id',
				element: <StaticControl />,
			},
			{
				path: 'lease-schedule/:id',
				element: <LeaseSchedule />,
			},
			{
				path: 'kpi-console/:id',
				element: <KpiConsoleStatic />,
			},
			{
				path: 'salary-management/:id',
				element: <SalaryManagementConsoleStatic />,
			},
			{
				path: 'lead-pipeline/:id',
				element: <LeadPipelineConsoleStatic />,
			},
			{
				path: 'lead-kanban/:id',
				element: <LeadKanbanConsoleStatic />,
			},
			{
				path: 'pre-litigation-kanban/:id',
				element: <PreLitigationKanbanConsoleStatic />,
			},
			{
				path: 'litigation-kanban/:id',
				element: <LitigationKanbanConsoleStatic />,
			},
			{
				path: 'legal-action-performance-manager/:id',
				element: <LegalActionPerformanceManagerConsoleStatic />,
			},
			{
				path: 'lead-ingestion-pool/:id',
				element: <LeadIngestionPoolConsoleStatic />,
			},
			{
				path: 'lead-back-office-workbench-v2/:id',
				element: <LeadBackOfficeWorkbenchV2ConsoleStatic />,
			},
			{
				path: 'scm-back-office-workbench/:id',
				element: <ScmBackOfficeWorkbenchConsoleStatic />,
			},
			{
				path: 'technical-evaluation-workbench',
				children: [
					{
						path: ':id',
						element: <TechnicalEvaluationWorkbenchConsoleStatic />,
					},
					{
						path: 'details',
						element: <TechnicalEvaluationWorkbenchDetailPage />,
					},
				],
			},
			{
				path: 'vendor-rfq-workbench',
				children: [
					{
						path: ':id',
						element: <VendorRfqWorkbenchConsoleStatic />,
					},
					{
						path: 'details/:workbenchId',
						element: <VendorRfqWorkbenchDetailPage />,
					},
				],
			},
			{
				path: 'invoice-matching-workbench',
				children: [
					{
						path: ':id',
						element: <InvoiceMatchingWorkbenchConsoleStatic />,
					},
					{
						path: 'details/:workbenchId',
						element: <InvoiceMatchingWorkbenchDetailPage />,
					},
				],
			},
			{
				path: 'invoice-matching',
				children: [
					{
						path: ':id',
						element: <InvoiceMatchingWorkbenchConsoleStatic />,
					},
					{
						path: 'details/:workbenchId',
						element: <InvoiceMatchingWorkbenchDetailPage />,
					},
				],
			},
			{
				path: 'scm-buyer-assignment/:id',
				element: <ScmBuyerAssignmentConsoleStatic />,
			},
			{
				path: 'scm-kanban/:id',
				element: <ScmKanbanConsoleStatic />,
			},
			{
				path: 'buyer-workbench/:id',
				element: <BuyerWorkbenchConsoleStatic />,
			},
			{
				path: 'lead-screening/:id',
				element: <LeadScreeningConsoleStatic />,
			},
			{
				path: 'lead-assignment/:id',
				element: <LeadAssignmentConsoleStatic />,
			},
			{
				path: 'lead-workbench/:id',
				element: <LeadWorkbenchConsoleStatic />,
			},
			// {
			// 	path: 'pre-litigation-workbench/:id',
			// 	element: <PreLitigationWorkbenchConsoleStatic />,
			// },
			{
				path: 'pre-litigation-workbench/:id',
				element: <PreLitigationWorkbenchNewConsoleStatic />,
			},
			{
				path: 'litigation-workbench/:id',
				element: <LitigationWorkbenchConsoleStatic />,
			},
			{
				path: 'team-kpi-evaluation/:id',
				element: <TeamKpiEvaluationStatic />,
			},
			{
				path: 'my-attendance/:id',
				element: <AttendanceSummary />,
			},
			{
				path: 'budgetary-control/:id',
				element: <BudgetaryControl />,
			},
			{
				path: 'invoice-ap-console',
				children: [
					{
						index: true,
						path: ':id',
						element: <InvoiceAPConsole />,
					},
					{
						path: 'details',
						element: <StaticInvoiceAPConsole screen="VIEW" />,
					},
				],
			},
			{
				path: 'invoice-treasury-console',
				children: [
					{
						index: true,
						path: ':id',
						element: <InvoiceTreasuryConsole />,
					},
					{
						path: 'details',
						element: <StaticInvoiceTreasuryConsole screen="VIEW" />,
					},
				],
			},
			{
				path: 'lease-schedule-v2/:id',
				element: <LeaseSecondConsoleV2 />,
			},
			{
				path: 'lease-schedule-v4/:id',
				element: <LeaseSecondConsoleV4 />,
			},
			{
				path: 'lease-schedule-v5/:id',
				element: <LeaseSecondConsoleV5 />,
			},
			{
				path: 'lease-schedule-v6/:id',
				element: <LeaseSecondConsoleV6 />,
			},
			{
				path: 'lease-schedule-v9/:id',
				element: <LeaseSecondConsoleV9 />,
			},
			{
				path: 'lease-accounting-v10/:id',
				element: <LeaseAccountingV10 />,
			},
			{
				path: 'lease-schedule-v7/:id',
				element: <LeaseSecondConsoleV7 />,
			},
			{
				path: 'lease-payable-v9/:id',
				element: <StaticLeasePayableV9Console />,
			},
			{
				path: 'lease-payable-approval-v9/:id',
				element: <StaticLeasePayableApprovalV9Console />,
			},
			{
				path: 'tax-payable/:id',
				element: <StaticTaxPayableConsole />,
			},
			{
				path: 'attendance-management/:id',
				element: <AttendanceManagement />,
			},
			{
				path: 'control-self-assurance/:id',
				element: <ControlSelfAssurance />,
			},
			{
				path: 'control-self-assurance-v2/:id',
				element: <ControlSelfAssuranceV2 />,
			},
			{
				path: 'petty-cash-float-dashboard/:id',
				element: <ListViewPettyCashFloatConsole />,
			},
			{
				path: 'decommission-asset-accounting/:id',
				element: <DecommissionAssetAccounting />,
			},
			{
				path: 'petty-cash-transaction/:id',
				element: <ListViewPettyCashTransactionConsole />,
			},
			{
				path: 'petty-cash-transaction-for-cashier/:id',
				element: <PettyCashTransactionForCasher />,
			},
			{
				path: 'petty-cash-reconciliation-dashboard/:id',
				element: <ListViewPettyCashReconciliationConsole />,
			},
			{
				path: 'fixed-asset-register/:id',
				element: <ListViewFixedAssetRegisterConsole />,
			},
			{
				path: 'kpi-comparative-console/:id',
				element: <KpiComparativeConsole />,
			},
			{
				path: 'acting-position-overview/:id',
				element: <ActingPositionOverview />,
			},
			{
				path: 'rate-agreement/:id',
				element: <RateAgreement />,
			},
			{
				path: 'project-milestone/:id',
				element: <ProjectMilestone />,
			},
			{
				path: 'rental-subscription/:id',
				element: <RentalSubscription />,
			},
			{
				path: 'consolidated-contract-administration/:id',
				element: <ConsolidatedContractAdministration />,
			},
			{
				path: 'fund-allocation-plan-workbench',
				children: [
					{
						index: true,
						path: ':id',
						element: <FundAllocationPlanWorkbench />,
					},
					{
						path: 'create',
						element: <FundAllocationPlanCreatePage screen="CREATE" />,
					},
					{
						path: 'edit',
						element: <FundAllocationPlanEditPage screen="EDIT" />,
					},
					{
						path: 'details',
						element: <FundAllocationPlanViewPage screen="VIEW" />,
					},
				],
			},
			{
				path: 'donor-company-disbursement-queue',
				children: [
					{
						index: true,
						path: ':id',
						element: <DonorCompanyDisbursementQueue />,
					},
					{
						path: 'details',
						element: <DonorCompanyDisbursementQueueDetailPage />,
					},
				],
			},
		],
	},
];
export default StaticSolutionRoutes;
